import BaseApiAction from '@Actions/base-api-action';
export default class GetTeamInfo extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-getTeamInfo',
      payload: {
        team_id: this._payload.team_id,
      }
    });
  }
}
